module.exports = __webpack_public_path__ + "3217701f8d91d5edea74bdf463eba5c8.svg";